<template>
  <div class="multiple">
    <div class="fu-radio-list flex-column">
      <div v-for="(option, index) in (test.options || [])" :key="index" class="flex-row wrapper" @click="baseInputClicked(option, index)">
        <div class="option-letter" :class="{ checkedStyle: actived[index] }">{{ indexes[index] }}</div>
        <div class="option-text">
          <div v-html="convertTestText(option.content)"></div>
        </div>
      </div>
    </div>
    <answer :test="test" v-if="showAnswer"></answer>
  </div>
</template>

<script>
import answer from './answer.vue'
export default {
  components: {
    answer,
  },
  name: 'multiple-test',
  props: {
    test: { // 题目数据
      type: Object,
      default: () => {},
    },
    testId: { // 题目id
      type: Number,
      default: () => null,
    },
    isMultipleType: { // 是否是多选题
      type: Boolean,
      default: () => false,
    },
    subIndex: { // 子题目索引
      type: Number,
      default: () => -1,
    },
    choiceAnswer: { // 选择的答案(提交后)
      type: String,
      default: () => '',
    },
    tempResult: { // 选择的答案(提交前)
      type: String,
      default: () => '',
    },
    showAnswer: { // 是否显示答案
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indexes: [],
      actived: [],
      checkedAnswer: {
        result: '',
        isRight: false,
      },
      checkedList: [],
    };
  },

  created() {
    this.clear();
  },

  mounted() {
    this.initData();
  },

  watch: {
    test(newValue) {
      this.clear();
      this.initData();
    },
    testId() {
      this.clear();
      this.initData();
    },
    tempResult(newValue) {
      if (newValue) {
        this.restoreFromTempResult(newValue);
      }
    },
  },
  methods: {
    initData() {
      const answer = this.tempResult || this.choiceAnswer;
      if (answer) {
        this.restoreFromTempResult(answer);
      }
    },
    restoreFromTempResult(result) {
      this.clear();
      const tempChoiceAnswer = result.split('');
      this.checkedList = tempChoiceAnswer;
      this.checkedAnswer = {
        result: result,
        isRight: result === this.test.answer,
      };
      tempChoiceAnswer.forEach((i) => {
        const key = this.indexes.findIndex((item) => item === i);
        if (key === -1) {
          return;
        }
        this.$set(this.actived, key, true);
      });
    },
    clear() {
      const options = this.test.options || [];
      this.indexes = this.handleAscii(options);
      this.checkedList = [];
      this.actived = new Array(options.length).fill(false);
      this.checkedAnswer = {
        result: '',
        isRight: false,
      };
    },
    baseInputClicked(option, index) {
      // 可同时选中多个选项
      this.$set(this.actived, index, !this.actived[index]);
      // 选中几个记录几个，选中再取消时将本条记录消除
      let result = this.indexes[index];
      if (this.actived[index] === true) {
        this.checkedList.push(result);
      } else {
        let idx = this.checkedList.indexOf(result);
        this.checkedList.splice(idx, 1);
      }
      let checkedList = this.checkedList.sort();
      result = checkedList.join('');
      let isRight = result === this.test.answer;

      this.checkedAnswer = { result, isRight };
      if (!this.isMultipleType) {
        this.$emit('fuCheckBoxListChecked', { result, isRight, subIndex: this.subIndex });
      }
      // 实时保存答案
      this.$emit('selectChange', result);
      // 如果不是需要显式提交的，直接触发 change 事件
      if (!this.isMultipleType) {
        this.$emit('change', this.checkedAnswer);
      }
    },
  },
};
</script>

<style scoped>
.fu-radio-list {
  margin-bottom: 10px;
  padding: 10px 24rpx 0;
}

.wrapper {
  justify-content: flex-start;
  margin-bottom: 10px;
}

.option-letter {
  margin-right: 10px;
  width: 33px;
  height: 33px;
  border: 1px solid #e4e4e4;
  border-radius: 50%;
  background-color: #fff;
  line-height: 33px;
  text-align: center;
  font-size: 17px;
  color: #333;
}

.option-text {
  display: flex;
  align-items: center;
  flex: 1;
  line-height: 22px;
  font-size: 17px;
  color: #000;
}

.checkedStyle {
  border: 1px solid #007aff;
  background: #007aff;
  color: #fff;
}
</style>
